import React, { useState } from "react";
import IconDisponivel from "../componentsStyled/icon/icondisponivel";
import IconVale from "../componentsStyled/icon/iconvale";
import { Box } from "@mui/material";

const CardVale: React.FC = () => {
  return (
    <Box display={"flex"} flexDirection={"row"} gap={10} marginTop={2} justifyContent={"center"}>
      <Box display={"flex"} flexDirection={"column"} gap={1} alignItems={"center"} width={130}>
        <IconDisponivel width={50} />
        <span style={{ textAlign: "center" }}>Disponível em até 5 dias úteis após a chegada do produto na Fut</span>
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={1} alignItems={"center"} width={130}>
        <IconVale width={50} />
        <span style={{ textAlign: "center" }}>Válido em todo o nosso site</span>
      </Box>
    </Box>
  );
};

export default CardVale;
